import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row, Card, CardBody } from 'reactstrap';

import { Input, Resource, Select, Editor } from '@/components/form';
import ResourceForm from '@/components/resources/form';
import View from '@/components/view';

const ZoneForm = ({ match }) => (
  <View>
    <ResourceForm resource="Zone" id={match.params.id}>
      {({ submitting, renderActions }) => (
        <>
          <Card>
            <CardBody className={submitting ? 'loading' : ''}>
              <Row>
                <Col lg={4}>
                  <Input name="name" />
                </Col>
                <Col lg={4}>
                  <Resource name="type" display="name" />
                </Col>
                <Col lg={4}>
                  <Input name="description" />
                </Col>
                <Col lg={6}>
                  <Select name="geometryType" />
                </Col>
                <Col lg={6}>
                  <Resource name="parent" display="name" clearable />
                </Col>
                <Col lg={12}>
                  <Editor name="coordinates" height="300" />
                </Col>
              </Row>
            </CardBody>
          </Card>
          <div className="mt-4 mb-4">{renderActions()}</div>
        </>
      )}
    </ResourceForm>
  </View>
);

ZoneForm.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({ id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]) })
  }).isRequired
};

export default ZoneForm;
